import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '../../../auth/services/authentication.service';

@Component({
  selector: 'sign-out',
  templateUrl: './sign-out.component.html',
  styleUrls: ['./sign-out.component.scss']
})
export class SignOutComponent implements OnInit {

  constructor(private authenticationService: AuthenticationService, private router: Router) { }

  async ngOnInit() {
    this.authenticationService.fireSignOut();

    await this.delay(1000);
    this.router.navigate(["/"]);
  }

  delay(ms: number) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

}
